import axios from "axios";
import sueldos from "../../models/conceptos/cSueldos";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getSalarieConcepts() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/csueldos`, { headers }).then(({ data }) =>
      data.map((item) => {
        return sueldos.fromJson(item);
      })
    );
  }

  getSalaryConceptId(csueldoid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/csueldos/${csueldoid}`, { headers })
      .then(({ data }) => data);
  }

  addSalaryConcept(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.nombre,
      sueldosIntCod: data.sueldosIntCod,
      sueldosStrCod: data.sueldosStrCod,
      conceptos: data.conceptos,
    };

    return axios.post(`${url}/csueldos`, payload, { headers });
  }

  editSalaryConcept(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      nombre: data.name,
      sueldosIntCod: Number(data.sueldosIntCod),
      sueldosStrCod: data.sueldosStrCod,
    };
    return axios
      .patch(`${url}/csueldos/${data.csueldoid}`, payload, { headers })
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteSalaryConcept(id) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(`${url}/csueldos/${id}`, { headers });
  }

  addConceptToSalary(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      conceptoId: Number(data.conceptId),
      cSueldoId: data.cSueldoId,
      fecDesde: data.fecDesde + "T00:00:00.000Z",
    };

    if (data.fecHasta) {
      payload.fecHasta =
        moment(data.fecHasta).add(1, "days").format("YYYY-MM-DD") +
        "T00:00:00.000Z";
    }

    return axios.post(`${url}/conceptos/csueldos`, payload, { headers });
  }

  editConceptToSalary(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {};
    if (data.dateStartInput !== undefined) {
      payload.fecDesde = data.dateStartInput + "T00:00:00.000Z";
    }

    if (data.dateEndInput) {
      payload.fecHasta =
        moment(data.dateEndInput).add(1, "days").format("YYYY-MM-DD") +
        "T00:00:00.000Z";
    }

    return axios
      .patch(
        `${url}/conceptos/csueldos/${data.conceptoId}&${data.csueldoId}&${data.fecDesdeOld}`,
        payload,
        { headers }
      )
      .then((response) => {
        return {
          status: response.status,
        };
      });
  }

  deleteConceptToSalary(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios.delete(
      `${url}/conceptos/csueldos/${data.conceptoId}&${data.cSueldoId}&${data.dateStartInput}`,
      { headers }
    );
  }
}

export default service;
